import { useMemo } from "react";

import { useGetUserProfileAPI } from "@/api/userProfile/useUserProfileAPI";
import {
  type ExploreDatasetMocks,
  getExploreDatasetMocks
} from "@/components/onboarding/configs/explore-dataset.mocks";

/**
 * Resolves the explore-dataset onboarding fixtures for the logged-in user's
 * country.
 *
 * Display-only: a Vietnam user sees the VN target dataset; every other country
 * (and an unresolved profile) falls back to the shared Indonesia bag. The
 * fixture ids are country-invariant, so the tour orchestration and the add /
 * attribute-filter seams are unaffected.
 *
 * Reads the *real* user profile (not the onboarding mock profile) so the country
 * reflects the actual user. The profile query is cached app-wide, so in practice
 * this is a cache read — it does not add an explorer network round-trip.
 */
export function useExploreDatasetMocks(): ExploreDatasetMocks {
  const { data: profile } = useGetUserProfileAPI();
  const countryCode = profile?.country?.code;
  return useMemo(() => getExploreDatasetMocks(countryCode), [countryCode]);
}
